import { createAction, createAsyncAction } from 'typesafe-actions';

import { LeadActionType } from './actionTypes';
import type {
  GetLeadByUuidRequestPayload,
  GetLeadByUuidResponsePayload,
  GetLeadSummariesRequestPayload,
  GetLeadSummariesResponsePayload,
  GetLeadSummaryByUuidRequestPayload,
  GetLeadSummaryByUuidResponsePayload,
  GetLeadsRequestPayload,
  GetLeadsResponsePayload,
  UtilStateRequestPayload,
} from './types';

export const getLeadsAction = createAsyncAction(
  LeadActionType.GET_LEADS_REQUEST,
  LeadActionType.GET_LEADS_SUCCESS,
  LeadActionType.GET_LEADS_FAILURE
)<GetLeadsRequestPayload, GetLeadsResponsePayload, Error>();

export const getLeadByUuidAction = createAsyncAction(
  LeadActionType.GET_LEAD_BY_UUID_REQUEST,
  LeadActionType.GET_LEAD_BY_UUID_SUCCESS,
  LeadActionType.GET_LEAD_BY_UUID_FAILURE
)<GetLeadByUuidRequestPayload, GetLeadByUuidResponsePayload, Error>();

export const getLeadSummariesAction = createAsyncAction(
  LeadActionType.GET_LEAD_SUMMARIES_REQUEST,
  LeadActionType.GET_LEAD_SUMMARIES_SUCCESS,
  LeadActionType.GET_LEAD_SUMMARIES_FAILURE
)<GetLeadSummariesRequestPayload, GetLeadSummariesResponsePayload, Error>();

export const getLeadSummaryByUuidAction = createAsyncAction(
  LeadActionType.GET_LAED_SUMMARY_BY_UUID_REQUEST,
  LeadActionType.GET_LAED_SUMMARY_BY_UUID_SUCCESS,
  LeadActionType.GET_LAED_SUMMARY_BY_UUID_FAILURE
)<
  GetLeadSummaryByUuidRequestPayload,
  GetLeadSummaryByUuidResponsePayload,
  Error
>();

export const leadsUtilStateChangeAction = createAction(
  LeadActionType.LEADS_UTIL_STATE_CHANGE
)<UtilStateRequestPayload>();

export const leadSummariesUtilStateChangeAction = createAction(
  LeadActionType.LEAD_SUMMARIES_UTIL_STATE_CHANGE
)<UtilStateRequestPayload>();
